import React from 'react';
import './style.scss';


const LoadingSpinner = () => (
  <div className="lds-css">
    <div className="lds-spinner">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./src/components/spinner/Spinner.jsx